import { render, staticRenderFns } from "./GlassesLensCreate.vue?vue&type=template&id=25ac37d8&"
import script from "./GlassesLensCreate.vue?vue&type=script&lang=js&"
export * from "./GlassesLensCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports